import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';
import { ApiError, FormExclusao, ItemLicencaOrganizacaoTemp } from '../../../services/tipos';

interface ItemLicencaOrganizacaoExclusaoProps {
    show: boolean;
    onHide: () => void;
    fonteDadosExcluidos: string[];
    onExcluir: (valor: boolean) => void;
    idItemLicencaOrganizacaoTemp: string;
    fonteDados: [ItemLicencaOrganizacaoTemp];
    setFonteDadosExcluidos: (fonteDados: string[]) => void;
    setFonteDados: (fonteDados: [ItemLicencaOrganizacaoTemp]) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function ItemLicencaOrganizacaoExclusao(props: ItemLicencaOrganizacaoExclusaoProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoItemLicencaOrganizacao, setCarregandoItemLicencaOrganizacao] = useState<boolean>(false);

    const [itemLicencaOrganizacaoTemp, setItemLicencaOrganizacaoTemp] = useState<ItemLicencaOrganizacaoTemp>({
        id: '',
        tempId: 0,
        valorItem: '',
        idItemLicenca: '',
        personalizado: true,
        idLicencaOrganizacao: '',
        idItemLicencaBase: undefined,
        itemLicenca: {
            id: '',
            nome: '',
            chave: '',
            tipoControle: '',
        },
    });

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        setCarregandoItemLicencaOrganizacao(true);
        let item: ItemLicencaOrganizacaoTemp[] = props.fonteDados.filter((item) => String(item.tempId) === String(props.idItemLicencaOrganizacaoTemp));

        if ((item.length > 0) && (item[0] !== null) && (item[0].itemLicenca !== null)) {
            setItemLicencaOrganizacaoTemp(item[0]);
        }

        setCarregandoItemLicencaOrganizacao(false);
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        let dados: [ItemLicencaOrganizacaoTemp] = [{
            id: '',
            tempId: 0,
            valorItem: '',
            idItemLicenca: '',
            personalizado: true,
            idLicencaOrganizacao: '',
            idItemLicencaBase: undefined,
            itemLicenca: {
                id: '',
                nome: '',
                chave: '',
                tipoControle: '',
            },
        }];

        function AddItemDados(item: ItemLicencaOrganizacaoTemp) {
            if (String(item.tempId) !== String(props.idItemLicencaOrganizacaoTemp)) {
                if (!dados[0]['tempId']) {
                    dados[0] = item;
                } else {
                    dados.push(item);
                }
            }
        }

        try {
            let dadosExcluidos = props.fonteDadosExcluidos;
            let item = props.fonteDados.filter((item) => String(item.tempId) === String(props.idItemLicencaOrganizacaoTemp));

            if ((item.length > 0) && (item[0].id)) {
                dadosExcluidos.push(item[0].id);
                props.setFonteDadosExcluidos(dadosExcluidos);
            }

            props.fonteDados.map(item => (
                AddItemDados(item)
            ));

            props.setFonteDados(dados);
            informarSucesso();
        } catch (error: any) {
            setCarregando(false);
            props.tratarErro(error, 'Não foi possível excluir o item da licença: ');
        }
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoItemLicencaOrganizacao
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            voltar={!!itemLicencaOrganizacaoTemp.idItemLicencaBase}
                            titulo={
                                itemLicencaOrganizacaoTemp.idItemLicencaBase
                                    ? 'Este item pertence a uma licença base e por este motivo não pode ser excluído'
                                    : `Deseja realmente excluir o item da licença ${itemLicencaOrganizacaoTemp.itemLicenca.nome}?`
                            } />
                }
            </Modal.Body>
        </Modal>
    );
}

export default ItemLicencaOrganizacaoExclusao;